<div class="col-md-4">
  <label class="form-label">Nome</label>
  <input
    class="form-control"
    name="usuarioNome"
    [(ngModel)]="usuario.nome"
    (ngModelChange)="emitirUsuario()"
    required>
</div>
<div class="col-md-4">
  <label class="form-label">E-mail</label>
  <input
    class="form-control"
    type="email"
    name="usuarioEmail"
    [(ngModel)]="usuario.email"
    (ngModelChange)="emitirUsuario()"
    required>
</div>
<div class="col-md-4">
  <label class="form-label">Senha</label>
  <input
    class="form-control"
    type="password"
    name="usuarioSenha"
    [(ngModel)]="usuario.senha"
    (ngModelChange)="emitirUsuario()"
    [required]="!usuario.id">
</div>
<div class="col-md-4">
  <label class="form-label">Perfil</label>
  <select
    class="form-select"
    name="usuarioPerfil"
    [(ngModel)]="usuario.perfil"
    (ngModelChange)="alterarPerfil()">
    <option value="ADMIN_EMPREGADOR">Administrador do empregador</option>
    <option value="ADMIN_GLOBAL">Administrador global</option>
  </select>
</div>
<div class="col-md-4">
  <label class="form-label">Empregador</label>
  <select
    class="form-select"
    name="usuarioEmpregador"
    [ngModel]="empregadorSelecionado"
    (ngModelChange)="empregadorSelecionadoChange.emit($event)"
    [disabled]="usuario.perfil === 'ADMIN_GLOBAL'">
    <option value="">Selecione</option>
    <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
  </select>
</div>
<div class="col-md-4">
  <label class="form-label">Departamentos permitidos</label>
  <select
    class="form-select"
    name="usuarioDepartamentos"
    multiple
    size="4"
    [ngModel]="usuario.departamentoIds || []"
    (ngModelChange)="alterarDepartamentos($event)"
    [disabled]="usuario.perfil === 'ADMIN_GLOBAL'">
    <option *ngFor="let departamento of departamentos" [value]="departamento.id">{{ departamento.nome }}</option>
  </select>
</div>
<div class="col-md-2 d-flex align-items-end">
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      name="usuarioAtivo"
      [(ngModel)]="usuario.ativo"
      (ngModelChange)="emitirUsuario()">
    <label class="form-check-label">Ativo</label>
  </div>
</div>
